import { render, staticRenderFns } from "./CompanyExpressionEditor.vue?vue&type=template&id=2ec2e5a0&scoped=true"
import script from "./CompanyExpressionEditor.vue?vue&type=script&lang=js"
export * from "./CompanyExpressionEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyExpressionEditor.vue?vue&type=style&index=0&id=2ec2e5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2e5a0",
  null
  
)

export default component.exports